<template>
  <div class="container">
    <div class="outer-bg" style="background:'bg'">
      <div class="pc_only">
        <img :src="bg" alt="" :style="{ textAlign: cent }" />
      </div>
      <div class="mobile_only">
        <img :src="mb_bg" alt="" :style="{ textAlign: cent }" />
      </div>
      <div :class="cent" class="mew">
        <h2>{{ title }}</h2>
        <p :class="fonts">{{ subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    cent: String,
    bg: String,
    fonts: String,
    mb_bg: String,
  },
}
</script>

<style scoped>
.pc_only {
  display: block;
}
.font_24 {
  font-size: 24px !important;
  min-width: 900px;
}
.font_20 {
  font-size: 20px !important;

  min-width: 600px;
}
.container {
  max-width: 1330px !important;
}
.outer-bg {
  margin: 0 auto;
  max-width: 1330px;
  text-align: center;
  position: relative;
  border-radius: 10px;
  max-height: 400px;
}
.outer-bg img {
  background-size: cover;
  width: 100%;
}
.relative-text-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.relative-text-left {
  text-align: left;
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);
  max-width: 500px;
}
.mew h2 {
  font: 700 3rem/3.75rem 'Open Sans';
  letter-spacing: -2.4px;
  color: #ffffff;
}

.mew p {
  padding-top: 30px;
  font: 400 1.5rem/2rem 'Open Sans';
  letter-spacing: 0px;
  color: #ffffff;
  word-wrap: break-word;
}
.mobile_only {
  display: none;
}
@media only screen and (max-width: 700px) {
  .pc_only {
    display: none;
  }
  .mew h2 {
    font: 700 1.25rem/3.75rem 'Open Sans';
    letter-spacing: -1px;
  }

  .mew p {
    padding-top: 0px;
    font: 400 0.875rem/1.125rem 'Open Sans';
    letter-spacing: 0px;
  }
  .font_24 {
    font-size: 14px !important;
    min-width: 295px;
  }
  .font_20 {
    font-size: 14px !important;
    min-width: 295px;
  }

  .relative-text-left {
    text-align: center;
    position: absolute;
    top: 27%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .mobile_only {
    display: block;
  }
}
</style>
